export default "__VITE_ASSET__C1K$Ij$m__"